module.exports = __webpack_public_path__ + "static/media/04.baa6a1db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flight/volumetric/baggage/04.png
// module id = 629
// module chunks = 0